import React from 'react';
import styles from './style.module.scss';
import Footer from 'components/footer';
import { Form, Input, Button, Checkbox } from 'antd';
import { LogoDarkIcon } from 'icons';
import LoginForm from './form';
import useAuth from './useAuth';

const LoginPage = () => {
  const { handleLogin, loadingBtn, errors } = useAuth();

  const onSubmit = (values) => {
    handleLogin(values);
  };

  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.loginPageContainer_content}>
        <div>
          <LogoDarkIcon />
        </div>
        <LoginForm
          errors={errors}
          loadingBtn={loadingBtn}
          onSubmit={onSubmit}
        />
      </div>
      <Footer />
    </div>
  );
};

export default LoginPage;
